export enum DocumentAttributes {
  innerHTML = 'innerHTML',
}
